<template>
  <div v-on:click="handleContentClick($event)">
    <v-card
      class="mx-auto contact-card"
    >
      <div class="desktop-container" v-html="cms_page.html"></div>
    </v-card>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";

export default {
  computed: {
    cms_page() {
      return hubbdata.getters.getCmsPageByPath('accessibility')
    },
  },
  mounted: function() {
    ga('set', 'title', "Terms"); // eslint-disable-line
    ga('send', 'pageview', location.href); // eslint-disable-line
  }
}
</script>

<style lang="scss" scoped>
.contact-card {
  height: 100%;
  border-radius: 0px;
  margin: 0px;
  padding: 30px;
}
</style>